<div class="c-kiosk-read-only">
  <label class="c-kiosk-readonly-label" for="c-kiosk-readonly-value">{{label | transloco}}</label>
  <div *ngFor="let val of values" class="c-kiosk-readonly-value">{{val}}</div>
</div>
